import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';
import {  Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PolicyStreetBannerComponent } from './components/policy-street-banner/policy-street-banner.component';
import { PolicyStreetServicesComponent } from './components/policy-street-services/policy-street-services.component';
import { PolicyStreetFormComponent } from './components/policy-street-form/policy-street-form.component';
import { LibertyService } from '../liberty-landing/liberty.service';

@Component({
    selector: 'app-insurance-policy-street',
    standalone: true,
    imports: [
        CommonModule,
        TranslateModule,
        FooterComponent,
        HeaderComponent,
        PolicyStreetBannerComponent,
        PolicyStreetServicesComponent,
        PolicyStreetFormComponent
    ],
    templateUrl: './insurance-policy-street.component.html',
    styleUrl: './insurance-policy-street.component.scss',
})
export class InsurancePolicyStreetComponent {
    clickedOutside: boolean = false;
    selectedLanguage: any;

    constructor(private router: Router, private toastr: ToastrService,private _libertyService:LibertyService) {
        this.selectedLanguage = localStorage.getItem('language');
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }

    /* HEADER AREA */
    closeMegaMenuCondition() {
        this.clickedOutside = !this.clickedOutside;
    }

    changeMenuCondition(event: any) {
        this.clickedOutside = false;
    }

    onSubmitPolicyStreetForm(data) {
        data.orgCode = "PSTR";
        data.employeeBenefitsPlan = data.employeeBenefitsPlan === "yes" ? "Y" : "N";
        this._libertyService.sendLibertyData(data).subscribe({
            next: (res) => {
                this.router.navigate(['/insurance/success'], {
                    queryParams: { source: 'policy-street' },
                    state: { id: res?.id },
                });
            },
            error: (err) => {
                this.toastr.error(err.error.message,'Error');
            },
        });
    }
}
